import K from './constants';
import crypto from 'crypto-js';
import restHelpers from '../helpers/restHelper';

const login = (username, password) => {
  const login_url = K.API_URL + '/authorize/token';
  const authdata = crypto.enc.Base64.stringify(crypto.enc.Utf8.parse(K.CLIENT_BASIC_AUTH));
  const headers = new Headers({ Authorization: 'Basic ' + authdata });
  return restHelpers.post(login_url, { headers, data: { username, password, grant_type: 'password' } });
};

const profile = () => {
  const profile_url = K.API_URL + '/api/v1/profile';
  return restHelpers.withBearer.get(profile_url, {});
};

const refreshToken = refresh_token => {
  const login_url = K.API_URL + '/authorize/token';
  const authdata = crypto.enc.Base64.stringify(crypto.enc.Utf8.parse(K.CLIENT_BASIC_AUTH));
  const headers = new Headers({ Authorization: 'Basic ' + authdata });
  return restHelpers.post(login_url, { headers, data: { refresh_token, grant_type: 'refresh_token' } });
};

export default {
  login,
  profile,
  refreshToken
};



// WEBPACK FOOTER //
// ./src/services/auth.js